import type { ReactNode } from "react";

import { cn } from "@homeinstead/ui";
import { FormError } from "@homeinstead/ui/components/FormError";

interface LeadFormErrorInlineProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

export function LeadFormErrorInline({
  children,
  className,
  id,
}: LeadFormErrorInlineProps) {
  return (
    <FormError.span
      className={cn("text-error", className)}
      id={id}
      role="alert"
    >
      {children}
    </FormError.span>
  );
}
